import React, {useContext, useEffect, useState} from 'react';
import {RecordsManagementContext} from '../StatesMangement/InitialiseContext';
import '../ClientPortal/ClientPortal.css';
import '../ClientInvoice/ClientInvoice.css'; // for signature styles
import './StoragePortal.css';
import SignaturePad from "../CommonComponents/SignaturePad";
import DefaultAlerts from "../CommonComponents/DefaultAlerts"; // added
import InvoicePaymentForm from "../ClientPortal/InvoicePaymentForm"; // added to reuse invoice payment modal form
import StoragePayNowModal from './StoragePayNowModal';
import ContactInfoForm from '../ClientPortal/ContactInformationForm'; // ADDED reuse existing contact info form/modal design

import axios from 'axios';
import {
    ShowStorageAddendumUrl,
    SubmitStorageAddendumUrl,
    RemoveStorageSignatureUrl,
    Elink,
    For,
    StorageIvnetoriesUrl,
    EmployeeKey,
    UnsubmitStorageAddendumData,
    PrintStorageUrl
} from '../CommonComponents/Routes';
import { Modal } from 'react-bootstrap';
import parse from 'html-react-parser';
import '../CommonComponents/ModalAndModalContent.css';
import ContactInformation from "../ClientPortal/ContactInformation";
import $ from 'jquery';

const StoragePortal = () => {
    let Record = useContext(RecordsManagementContext)
    const { SP_PageDetails, SetSP_PageDetails } = useContext(RecordsManagementContext);
    const [showAddendumModal,setShowAddendumModal] = useState(false)
    const [showPayNowModal,setShowPayNowModal] = useState(false)
    const [loading,setLoading] = useState(false)
    const [selectedAddendum,setSelectedAddendum] = useState('')
    const [selectedAddendumForSignature, setSelectedAddendumForSignature] = useState(null)
    const [buttonIdForSignature, setButtonIdForSignature] = useState(null)
    const [showStorageContactModal, setShowStorageContactModal] = useState(false)
    const [allInventoryList, setAllInventoryList] = useState([]);
    const [showAllInventoryModal, setShowAllInventoryModal] = useState(false); // RENAMED
    const [allInventorySummary, setAllInventorySummary] = useState({Cuft:0,Lbs:0,Count:0}); // ADDED summary for full list
    const [customPaymentCompleted, setCustomPaymentCompleted] = useState(false); // ADDED state to track custom payment completion
    const [showFullHistoryModal, setShowFullHistoryModal] = useState(false); // ADDED modal state for full billing history
    const closeModal = () => {
        Record.setShowSignatureModal(false)
        setSelectedAddendumForSignature(null);
        setButtonIdForSignature(null);
    }
    // Bridge: allow HTML content buttons to call openSignaturePad() and open React signature modal
    useEffect(() => {
        // Define globally so inline HTML onclick can access it
        window.openSignaturePad = function(button) {
            try {
                const addId = selectedAddendum || selectedAddendumForSignature || ''
                if (addId) setSelectedAddendumForSignature(addId)
                if (button) setButtonIdForSignature(button.id || null)
                Record.setShowSignatureModal(true);
            } catch (e) {
                console.error('Failed to open signature pad from content:', e);
            }
        };
        // Expose existing removeSignature so addendum HTML can call removeSignature()
        window.removeSignature = function(document_id) {
            try { removeSignature(document_id); } catch (e) { console.error('Failed to remove signature from content:', e); }
        };
        return () => {
            try { delete window.openSignaturePad; } catch(_) {}
            try { delete window.removeSignature; } catch(_) {}
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedAddendum, selectedAddendumForSignature]);
    // Provide safe defaults to avoid runtime errors if API returns partial object
    const {
        Header = {},
        StorageAccount = {},
        InventorySummary = {},
        Consultant = {},
        Notes = '',
        Background = {},
        CompanyBranch = {}
    } = SP_PageDetails || {};
    const ContactPersons = SP_PageDetails.ContactPersons;
    const BillingHistory = SP_PageDetails.BillingHistory || [];

    // Removed optional chaining for CRA 2.x compatibility
    const bg1 = (Background && Background.BgColor1) || '#e7f5ff'; // lighter gradient to match screenshot
    const bg2 = (Background && Background.BgColor2) || '#b3dff6';
    // BEGIN enhanced inventory extraction logic
    const extractInventoryArray = () => {
        // Prefer PercentageInventoriesEstimate (matches ManageOrShowInventory pattern)
        if (SP_PageDetails && SP_PageDetails.Inventory) {
            return SP_PageDetails.Inventory.List;
        }
        return [];
    };
    const rawInventoryList = extractInventoryArray();
    const inventoryList = rawInventoryList.slice(0, 8); // SHOW ONLY FIRST 8
    // calculate (cuft/lbs) -------------start------------------
    const hasProvidedSummary = InventorySummary && (InventorySummary.Cuft || InventorySummary.Lbs);
    const computedSummary = rawInventoryList.reduce((acc, it) => {
        const qty = parseFloat(it.Qty || it.Quantity) || 1; // support Qty field shape
        const cuft = parseFloat(it.Cuft) || 0;
        const lbs = parseFloat(it.Lbs) || 0;
        acc.Cuft += cuft * qty;
        acc.Lbs += lbs * qty;
        acc.Count += qty;
        return acc;
    }, {Cuft: 0, Lbs: 0, Count: 0});
    const inventorySummaryDisplay = hasProvidedSummary ? {
        Cuft: parseFloat(InventorySummary.Cuft) || 0,
        Lbs: parseFloat(InventorySummary.Lbs) || 0,
        Count: rawInventoryList.length
    } : computedSummary;
    // END enhanced inventory extraction logic
    const billingList = (BillingHistory || []).slice(0, 12);

    // Fallback button colors (per screenshot styling expectations)
    const buttonColor = (Header && Header.ButtonColor) || {
        addendums: '#26a9e0',
        paynow: '#26a9e0',
        updatebilling: '#850000',
        printstorage: '#8897aa',
        signstorage: '#0ff500'
    };

    // Function to calculate luminance from hex color (mirrors ClientPortalHeader logic)
    const calculateLuminance = (backgroundColor) => {
        if (!backgroundColor) return 'white';
        if (backgroundColor === '#ffffff' || backgroundColor === '#FFFFFF') return 'black';
        if (backgroundColor === '#000000' || backgroundColor === '#000000') return 'white';
        const hex = backgroundColor.replace('#','');
        if (hex.length !== 6) return 'white';
        const r = parseInt(hex.slice(0,2),16);
        const g = parseInt(hex.slice(2,4),16);
        const b = parseInt(hex.slice(4,6),16);
        const luminance = 0.299 * r + 0.587 * g + 0.114 * b;
        return luminance > 220 ? 'black' : 'white';
    };

    // Shared elevated card style
    const cardStyle = {
        fontSize: '12px',
        borderRadius: '6px',
        background: '#ffffff',
        border: '1px solid #e2e2e2'
    };


    const estimatedCostCellStyle = {
        borderLeft: '1px solid #d3d3d3',
        borderRight: '1px solid #d3d3d3',
        textAlign: 'center',
        verticalAlign: 'middle'
    };

    const estimatedCostCellHeaderStyle = {
        borderTop: '1px solid #d3d3d3', color: '#000', fontSize: '15px', fontWeight: 400, textAlign: 'center'
    };
    const addendumTableStyle = {
        border: '1px solid #d3d3d3', color: '#000', fontSize: '15px', fontWeight: 200, textAlign: 'center'
    };
    // Attach scroll listener to mimic sticky header border/shadow like client portal
    useEffect(() => {
        const headerEl = document.getElementById('scroll_navbar');
        if (!headerEl) return;
        const onScroll = () => {
            headerEl.style.borderBottom = window.scrollY > 0 ? '1px solid #26a9e0' : '';
        };
        window.addEventListener('scroll', onScroll);
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    // Enhanced Button component with hover shadow & scale effect
    const Button = ({ show, text, color, onClick }) => {
        const [hover, setHover] = useState(false);
        if (!show) return null;
        return (
            <div
                className="btn-right d-flex"
                style={{
                    background: color,
                    color: calculateLuminance(color),
                    border: `1px solid ${color}`,
                    borderRadius: '4px',
                    padding: '6px 10px',
                    fontSize: '11px',
                    letterSpacing: '0.5px',
                    cursor: 'pointer',
                    transition: 'transform .2s ease',
                    transform: hover ? 'translateY(-2px)' : 'translateY(0)'
                }}
                onClick={onClick}
                onMouseEnter={()=>setHover(true)}
                onMouseLeave={()=>setHover(false)}
            >{text}</div>
        );
    };

    // Helper: treat undefined/null as visible; only hide when explicitly false or 0
    const isVisible = (val) => !(val === false || val === 0);

    // Print storage portal PDF (pattern similar to client portal print). Optional fields to avoid runtime errors.
    const printStoragePortal = () => {
        if (Header && Header.PrintPortal && Header.PrintPortal.url) {
            const Url = `${Header.PrintPortal.url}/print_storage_portal?storage_id=${Elink}`;
            window.open(Url);
        } else if (PrintStorageUrl && SP_PageDetails.StorageAccountId) {
            window.open(`${PrintStorageUrl}?storage_id=${SP_PageDetails.StorageAccountId}`)
        }
    };

    const handleAddendums = () => {
        if (!Array.isArray(SP_PageDetails.Addendums) || SP_PageDetails.Addendums.length === 0){ return }
        setSelectedAddendum(''); // RESET previously selected addendum so modal opens in a neutral state
        setShowAddendumModal(true)
    };
    const fetchAddendum = async (id) => {
        if (!id) return;
        setLoading(true)
        try {
            const resp = await axios({method:'post', url: ShowStorageAddendumUrl, params:{ addendum_id:id, Storage_key: Elink, employee_key: EmployeeKey }})
            SetSP_PageDetails({...SP_PageDetails, Addendums: resp.data.Addendums,AddendumsDetailed: resp.data.AddendumsDetailed  })
            setSelectedAddendum(id)
            setSelectedAddendumForSignature(id)
        } catch(e){ console.error('Addendum fetch error', e) }
        setLoading(false)
    }
    const submitAddendum = async () => {
        if (!selectedAddendum) return;
        setLoading(true)
        try {
            const resp = await axios({method:'post', url: SubmitStorageAddendumUrl, params:{submit_addendum: true, addendum_id: selectedAddendum, Storage_key: Elink }})
            if (resp.data && resp.data.status === 'ok') {
                alert('Addendum saved successfully.')
                setShowAddendumModal(false)
                setSelectedAddendum("")
                setSelectedAddendumForSignature(null);
                setButtonIdForSignature(null);
            } else {
                alert('Save failed.')
            }
        } catch(e){ alert('Request failed.'); }
        setLoading(false)
    }

    const unsubmitAddendum = async () => {
        if (!selectedAddendum) return;
        setLoading(true);
        try {
            const resp = await axios({method:'post', url: UnsubmitStorageAddendumData, params:{ addendum_id: selectedAddendum, Storage_key: Elink }});
            const updatedDetailed = (resp.data.AddendumsDetailed || []).map(a => {
                if (a.id && a.id.toString() === selectedAddendum.toString()) {
                    return { ...a, submitted: false, submit_addendum: false }; // clear flags
                }
                return a;
            });
            SetSP_PageDetails({ ...SP_PageDetails, AddendumsDetailed: updatedDetailed });
            alert('Addendum unsubmitted successfully.');
        } catch(e){
            alert('Failed to unsubmit addendum.');
        }
        setLoading(false);
    }

    const handlePayNow = () => setShowPayNowModal(true);
    const handleUpdateBilling = () => Record.setInvoicePaymentModal(true);
    const handleSignStorage = async () => {
        if (SP_PageDetails.StorageSignature && SP_PageDetails.StorageSignature.Signed){ return }
        setLoading(true)
        try {
            Record.setShowSignatureModal(true)
        } catch(e){ console.error('Signature pad fetch error', e) }
        setLoading(false)
    };
    const removeSignature = async (documentId) => {
        // When documentId is provided, treat this as an addendum document signature removal
        if ((typeof documentId) == 'string' || (typeof documentId) == 'number') {
            if (!window.confirm('Are you sure you want to remove this addendum document?')) return;
            setLoading(true);
            try {
                await axios({ method:'post', url: RemoveStorageSignatureUrl, params:{ Storage_key: Elink, remove: 'AddendumSign', document_id: documentId } });
                if (selectedAddendum) { await fetchAddendum(selectedAddendum); }
            } catch(e){ console.error('Remove addendum document error', e) }
            setLoading(false);
            setSelectedAddendumForSignature(null);
            setButtonIdForSignature(null);
        }
        else {
            if (!SP_PageDetails.StorageSignature || !SP_PageDetails.StorageAccountId) return;
            if (!window.confirm('Are you sure?')) return;
            setLoading(true)
            try {
                await axios({method:'post', url: RemoveStorageSignatureUrl, params:{ Storage_key: Elink }})
                SetSP_PageDetails({...SP_PageDetails,Header: { ...SP_PageDetails.Header, ShowSignStorage: true }, StorageSignature:{ Signed:false, Url:'', Text:'' }})
            } catch(e){ console.error('Remove signature error', e) }
            setLoading(false)
        }
    }

    // Derive logo similar to client portal but using company branch logo like EstimateAndCompanyInfo
    const portalLogo = (CompanyBranch && CompanyBranch.Logo) || (process.env.PUBLIC_URL + '/mip-square-logo.png');

    // initialize editable contacts when SP_PageDetails changes
    useEffect(() => {
        // removed editableContacts initialization (handled inside ContactInfoForm for storage mode)
    }, [SP_PageDetails]);

    const closeStorageContactModal = () => setShowStorageContactModal(false);
    // Derived display values to better mirror screenshot styling
    const nextChargeDateDisplay = StorageAccount.NextChargeDate || '';
    const autoPayDisplay = StorageAccount.AutoPay ? 'Yes' : 'No';
    const monthlyFeeDisplay = StorageAccount.MonthlyFee ? `${StorageAccount.MonthlyFee}` : '';
    const estimateNumberDisplay = StorageAccount.EstimateNumber ? `#${StorageAccount.EstimateNumber}` : 'N/A';

    const fetchPortalInventories = async () => {
        // Fetch initial (or refreshed) inventory list into SP_PageDetails.Inventory.List using PercentageInventoriesEstimate
        if (loading) return;
        setLoading(true);
        try {
            const params = For === 'storage' ? { Storage_key: Elink, For: For } : { estimate_key: Elink };
            const response = await axios({ method: 'post', url: StorageIvnetoriesUrl, params });
            let fetchedList = response.data.Inventories;
            // Unwrap possible nested structures
            if (fetchedList && fetchedList.List && Array.isArray(fetchedList.List)) fetchedList = fetchedList.List;
            // If it's an object keyed by id, convert to array
            if (fetchedList && typeof fetchedList === 'object') {
                fetchedList = Object.values(fetchedList);
            }
            if (Array.isArray(fetchedList) && fetchedList.length > 0) {
                SetSP_PageDetails({ ...SP_PageDetails, Inventory: { List: fetchedList } });
            }
        } catch (err) {
            console.error('Initial inventory fetch failed:', err);
        }
        setLoading(false);
    };
    // Auto-fetch inventories if none present after storage records load
    useEffect(() => {
        if (StorageIvnetoriesUrl && rawInventoryList.length === 0) {
            fetchPortalInventories();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [SP_PageDetails.StorageAccountId]);

    const fetchAllInventories = async () => {
        if (loading) return;
        if (allInventoryList.length > 0) {
            setShowAllInventoryModal(true);
            return;
        }
        setLoading(true);
        try {
            const params = For === 'storage' ? { Storage_key: Elink, For: For } : { estimate_key: Elink };
            const response = await axios({ method: 'post', url: StorageIvnetoriesUrl, params });
            let fullList = response.data.Inventories;
            fullList = Object.values(fullList);
            setAllInventoryList(fullList);
            const summary = fullList.reduce((acc,it)=>{
                const qty = parseFloat(it.Qty || it.Quantity) || 1;
                const cu = parseFloat(it.Cuft || it.CuFt) || 0;
                const lb = parseFloat(it.Lbs) || 0;
                return {Cuft: acc.Cuft + cu * qty, Lbs: acc.Lbs + lb * qty, Count: acc.Count + qty};
            }, {Cuft:0,Lbs:0,Count:0});
            setAllInventorySummary(summary);
            setShowAllInventoryModal(true);
        } catch (error) {
            console.error('Error fetching all inventories:', error);
            setAllInventoryList([]);
            setAllInventorySummary({Cuft:0,Lbs:0,Count:0});
            setShowAllInventoryModal(true);
        }
        setLoading(false);
    };

    // Bind storage addendum content changes to jQuery event (for fields inside addendum content)
    useEffect(() => {
        bindStorageAddendumContentChanges();
        return () => {
            $(document).off('change.storageAddendum');
        };
    }, [selectedAddendum, SubmitStorageAddendumUrl]);

    const bindStorageAddendumContentChanges = () => {
        if (!selectedAddendum) return;
        if (!SubmitStorageAddendumUrl) { console.warn('SubmitStorageAddendumUrl is not defined; cannot persist addendum field changes.'); return; }
        $(document).off('change.storageAddendum', '.text_field, .text_area, .check-box , .portal-radio-btn');
        $(document).on('change.storageAddendum', '.text_field, .text_area, .check-box , .portal-radio-btn', function () {
            const $el = $(this);
            const isRadio = $el.hasClass('portal-radio-btn');
            const isCheckbox = $el.hasClass('check-box');
            console.log(isRadio);
            const content_type = isRadio ? $el.attr('name') : $el.attr('id');
            let content_value = isRadio ? ($el.val() || '').replace('Addendum', 'portal') : $el.val();
            console.log(content_type);
            if (isCheckbox) {
                ($el.val() === 'true') ? $el.val('false') : $el.val('true');
                content_value = $el.val();
            }
            $.ajax({
                type: 'POST',
                url: SubmitStorageAddendumUrl,
                data: {
                    Storage_key: Elink,
                    addendum_id: selectedAddendum,
                    val: content_value,
                    content_type: content_type,
                }
            }).fail(function(err){ console.error('Failed to save storage addendum field', err); });
        });
    };

    return (
        // Outer container now mirrors ClientPortal
        <div className="storage-portal-root" style={{backgroundColor: '#172b4d', backgroundImage: `linear-gradient(45deg, ${bg1} 15%, ${bg2} 85%)`, scrollBehavior: 'smooth', minHeight:'100vh'}}>
            <div className="width-wrapper">
                {/* Sticky header */}
                {/* Main content wrapper like client portal */}
                <DefaultAlerts/> {/* Render alerts just below sticky header */}
                <div className="estimate-services-wrap">
                <div className="estimate-wrap scroll_navbar" id="scroll_navbar" style={{position:'sticky', top:0, zIndex:80}}>
                        <div className="estimate-number">
                            {/* Modified header layout: buttons now right-aligned */}
                            <div className="top-estimate d-flex align-items-center flex-wrap" style={{paddingTop:'10px'}}>
                                <div className="ph-number-wp d-flex align-items-center mb-2" style={{minWidth:'220px'}}>
                                    <div className="ph-number" style={{marginLeft:'0px'}}>
                                        <img src={`${process.env.PUBLIC_URL}/Images/phone.png`} alt="Phone" />
                                    </div>
                                    <div className="ph-contact" style={{marginLeft:'6px'}}>
                                        <p className="mb-0 text-muted" style={{fontSize:'11px'}}>Call us anytime</p>
                                        <h6 style={{marginBottom:0}}>{Header.CompanyBranchPhnNumber || ''}</h6>
                                    </div>
                                </div>
                                <div className="print-btns d-flex flex-wrap ml-auto justify-content-end" style={{gap:'6px'}}>
                                    <Button show={isVisible(Header.ShowAddendums)} text="Addendums" color={buttonColor.addendums} onClick={handleAddendums} />
                                    <Button show={isVisible(Header.ShowPayNow) && !customPaymentCompleted} text="Pay Now" color={buttonColor.paynow} onClick={handlePayNow} />
                                    <Button show={isVisible(Header.ShowUpdateBilling)} text="Update Billing Information" color={buttonColor.updatebilling} onClick={handleUpdateBilling} />
                                    <Button show={isVisible(Header.ShowPrintStorage)} text="Print Storage" color={buttonColor.printstorage} onClick={printStoragePortal} />
                                    <Button show={isVisible(Header.ShowSignStorage) && !(SP_PageDetails.StorageSignature && SP_PageDetails.StorageSignature.Signed)} text="Sign Storage" color={buttonColor.signstorage} onClick={handleSignStorage} />
                                </div>
                            </div>
                        </div>
                </div>
                    {/* Removed old standalone company-branch-details block */}
                    {/* Begin unified Storage Statement + Logo + Company Branch row */}
                    <div className="container">
                        <div className="row mb-2">
                            <div className="col-sm-4">
                                <div className="estimate-services">
                                    <h4 style={{fontWeight:600, color:"black"}}>Storage Statement</h4>
                                </div>
                            </div>
                            <div className="col-sm-4 text-sm-center">
                                <div className="logo-container">
                                    <img
                                        src={portalLogo}
                                        alt="Company Logo"
                                        className="responsive-logo"
                                    />
                                </div>
                            </div>
                            <div className="col-sm-4 text-sm-right">
                                <div className="estimate-services">
                                    <h4>{CompanyBranch.Name || ''}</h4>
                                    <div className="booked-btn">
                                        {CompanyBranch.Address && <span>{CompanyBranch.Address}</span>}
                                        {CompanyBranch.SuiteNumber && <span>Suite/Unit Number: {CompanyBranch.SuiteNumber}</span>}
                                        {CompanyBranch.StateAuthority && <span>{CompanyBranch.StateAuthority}</span>}
                                        {CompanyBranch.UsDot && <span>{CompanyBranch.UsDot}</span>}
                                        {CompanyBranch.Mail && <span>{CompanyBranch.Mail}</span>}
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* Removed old <h5>Storage Statement</h5> and separate logo-container */}
                        <div className="row mt-2">
                            <div className="col-12">
                                <div className="card" style={{...cardStyle, padding:'10px 14px'}}>{StorageAccount.Verbiage || 'Storage Portal Verbiage'}</div>
                            </div>
                        </div>
                        <div className="row mt-3">
                            <div className="col-lg-4">
                                <div>
                                    <ContactInformation/>
                                </div>
                                {/* Consultant */}
                                <div className="contact-information mb-3" style={{...cardStyle, padding:'10px'}}>
                                    <ul className="contact-info-list pl-0 mb-0" style={{listStyle:'none'}}>
                                        <li><h6 style={{fontWeight:600}}>Consultant</h6></li>
                                        <li>
                                            <div className="row" >
                                                <div className="col-7">
                                                    <span style={{color:'#222', fontWeight:400}}>Created By...</span>
                                                    <div className="estimated-by">
                                                        {Consultant.Name && <h5>{Consultant.Name}</h5>}
                                                        {Consultant.Email && <span style={{display:'block', color:'#707070'}}>{Consultant.Email}</span>}
                                                        {Consultant.CreatedBy && <span style={{display:'block', color:'#707070'}}>Created By: {Consultant.CreatedBy}</span>}
                                                        {StorageAccount.CreatedOn && <span style={{display:'block', color:'#707070'}}>Created On: {StorageAccount.CreatedOn}</span>}
                                                    </div>
                                                </div>
                                                <div className="col-5">
                                                    <div className="estimated-user">
                                                        {Consultant.ProfilePic && (
                                                            <img src={Consultant.ProfilePic} alt="Consultant Profile" />
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="signature-img text-left">
                                                {Consultant.SuperUserPresent ?
                                                    <div style={{fontSize:" 40px",fontFamily:"Agreement Signature",paddingTop:"2px"}}>
                                                        {Consultant.SignaturePic}
                                                    </div>
                                                    :
                                                    <img  src={Consultant.SignaturePic} alt="Employee Sign"/>
                                                }

                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-lg-8">
                                <div className="estimate-time-mapping mb-3" style={{...cardStyle}}>
                                    <ul className="time-mapping-list pl-0 mb-0 d-flex flex-wrap" style={{listStyle:'none'}}>
                                        {[{label:'Next Charge Date', value:nextChargeDateDisplay},{label:'Auto Pay', value:autoPayDisplay},{label:'Monthly Fee', value:monthlyFeeDisplay},{label:'Estimate No.', value:estimateNumberDisplay}].map((box,i)=>(
                                            <li key={i} style={{flex:'1 1 140px'}}>
                                                <div className="estimate-arrival-time" style={{textAlign:'left'}}>
                                                    <h6 style={{fontSize:'15px', fontWeight:600, marginBottom:'2px'}}>{box.value}</h6>
                                                    <span style={{fontSize:'12px', color:'#606060'}}>{box.label}</span>
                                                </div>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                                <div id="inventory-section" className="card" style={{...cardStyle, padding:'12px'}}>
                                    <div className="text-center" style={{marginBottom:'6px'}}>
                                        <div style={{color:'#000', fontSize:'15px', fontWeight:600}}>Inventory</div>
                                        <div style={{fontSize:'12px', fontWeight:600, color:'#26a9e0'}}>{(inventorySummaryDisplay.Cuft || 0).toFixed(2)} CuFt / {(inventorySummaryDisplay.Lbs || 0).toFixed(2)} lbs</div>
                                        <div style={{fontSize:'12px'}}>{rawInventoryList.length} Items</div>
                                    </div>
                                    <div style={{overflowX:'auto'}}>
                                        <table className="estimated-cost-tbl table table-sm mb-2" style={{borderBottom:'1px dashed #9f9e9e', borderCollapse:'collapse', width:'100%'}}>
                                            <tbody>
                                            <tr style={{fontSize:'12px', color:'#000'}}>
                                                <th style={{...estimatedCostCellStyle, ...estimatedCostCellHeaderStyle}}>Quantity</th>
                                                <th style={{...estimatedCostCellStyle, ...estimatedCostCellHeaderStyle}}>Item(s)</th>
                                                <th style={{...estimatedCostCellStyle, ...estimatedCostCellHeaderStyle}}>CuFt</th>
                                                <th style={{...estimatedCostCellStyle, ...estimatedCostCellHeaderStyle}}>Lbs</th>
                                            </tr>
                                            {inventoryList.map((inv,i)=>(
                                                <tr key={i} style={{fontSize:'12px'}}>
                                                    <td style={estimatedCostCellStyle}>{inv.Qty || inv.Quantity || 1}</td>
                                                    <td style={estimatedCostCellStyle}>{inv.Name || inv.Item || 'Unnamed Item'}</td>
                                                    <td style={estimatedCostCellStyle}>{inv.Cuft || inv.CuFt || 0}</td>
                                                    <td style={estimatedCostCellStyle}>{inv.Lbs || 0}</td>
                                                </tr>
                                            ))}
                                            {inventoryList.length === 0 && (
                                                <tr><td colSpan={4} style={{textAlign:'center', fontSize:'11px', color:'#777'}}>No inventory items found.</td></tr>
                                            )}
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="d-flex justify-content-center">
                                        {/* Show All Inventory already styled correctly */}
                                        <button
                                            className="update-btn"
                                            id="showAllInventoryButton"
                                            onClick={fetchAllInventories}
                                            disabled={loading}
                                        >
                                            {loading ? 'Loading...' : 'Show All Inventory'}
                                        </button>
                                    </div>
                                </div>
                                <div id="signature-section" className="card mb-3 p-0" style={{...cardStyle, padding:'12px'}}>
                                    <div style={{fontSize:'12px', textAlign:'left'}}>
                                        {(() => {
                                            const loadingState = localStorage.getItem('loading');
                                            const hasSignature = SP_PageDetails.StorageSignature && SP_PageDetails.StorageSignature.Url;
                                            if (hasSignature) {
                                                return (
                                                    <div style={{display:'flex', alignItems:'flex-start'}}>
                                                        <div>
                                                            <div className="btn" onClick={removeSignature}>X</div>
                                                            <img src={SP_PageDetails.StorageSignature.Url}
                                                                 className="img-rounded sign_1_image" alt="Customer Signature"/>
                                                            <div style={{borderTop: '2px dashed #9f9e9e'}}></div>
                                                            <p className="sign_1_date" style={{color: 'grey', marginTop: '1px', textAlign: 'right', fontSize: '10px'}}>{SP_PageDetails.StorageSignature.UpdatedAt || SP_PageDetails.StorageSignature.Date || ''}</p>
                                                        </div>
                                                    </div>
                                                );
                                            }
                                            if (loadingState === 'yes') {
                                                return (
                                                    <div style={{textAlign:'left'}}>
                                                        <img src={process.env.PUBLIC_URL + '/Images/Loader18.gif'} alt="Loading Signature" className="sign_1_image" />
                                                    </div>
                                                );
                                            }
                                            return (<p style={{fontSize:'11px', color:'#9f9e9e', marginBottom:0}}>No signature found</p>);
                                        })()}
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* Billing History */}
                        <div id="billing-section" className="row">
                            <div className="col-12">
                                <div className="card p-2 mb-3" style={{...cardStyle, padding:'10px'}}>
                                    <div style={{overflowX:'auto'}}>
                                        <table className="estimated-cost-tbl table table-sm mb-0">
                                            <tbody>
                                            <tr style={{fontSize:'12px'}}>
                                                <th style={{...addendumTableStyle, fontWeight: 600}}>Bill Date</th>
                                                <th style={{...addendumTableStyle, fontWeight: 600}}>Description</th>
                                                <th style={{...addendumTableStyle, fontWeight: 600}}>Monthly Fees</th>
                                                <th style={{...addendumTableStyle, fontWeight: 600}}>Charged</th>
                                                <th style={{...addendumTableStyle, fontWeight: 600}}>Balance</th>
                                                <th style={{...addendumTableStyle, fontWeight: 600}}>Charged Info</th>
                                                <th style={{...addendumTableStyle, fontWeight: 600}}>Pre-paid Credits</th>
                                            </tr>
                                            {billingList.map((b,i)=>(
                                                <tr key={i} style={{fontSize:'12px'}}>
                                                    <td style={addendumTableStyle}>{b.BillDate}</td>
                                                    <td style={addendumTableStyle}>{b.Description}</td>
                                                    <td style={addendumTableStyle}>{b.MonthlyFee}</td>
                                                    <td style={addendumTableStyle}>
                                                        <span style={b.ChargedStriked ? {textDecoration: 'line-through', textDecorationColor: '#ff0000'} : undefined}>{b.Charged}</span> <span>{b.StatusText}</span>
                                                    </td>
                                                    <td style={addendumTableStyle}>{b.Balance}</td>
                                                    <td style={addendumTableStyle}>{b.ChargedInfo}</td>
                                                    <td style={addendumTableStyle}>{b.PrepaidCredits}</td>
                                                </tr>
                                            ))}
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="d-flex justify-content-center mt-2">
                                        {/* Converted div to button, removed inline styles, added update-btn */}
                                        <button className="update-btn" id="showFullHistoryButton" onClick={()=> setShowFullHistoryModal(true)}>Show Full History</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* Notes */}
                        <div id="notes-section" className="row">
                            <div className="col-12">
                                <div className="contact-information mb-3" style={{...cardStyle, padding:'10px'}}>
                                    <ul className="contact-info-list pl-0 mb-0" style={{listStyle:'none'}}>
                                        <li><h6 style={{fontWeight:600}}>Storage Notes</h6></li>
                                        {((Notes && Notes !== [] ? Notes : 'Storage Notes Not present')
                                            .filter(line => line.trim() !== '')
                                            .map((line,i)=> (
                                                <li key={i+"note"} style={{padding:'2px 0'}}><span>{parse(line)}</span></li>
                                            )))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <a href="https://www.moveitpro.com/privacy-policy" target="_blank" rel="noopener noreferrer" className="footer-link pt-3 ml-4" style={{display:'inline-block', color:'#585858', fontSize:'11px'}}>Privacy Policy</a>
                    </div>{/* end container */}
                </div>{/* end estimate-services-wrap */}

                {/* Modals */}
                {showAddendumModal && (
                    <div className="modal-portal" style={{position:'fixed',top:0,left:0,right:0,bottom:0,background:'rgba(0,0,0,0.6)',zIndex:999}}>
                        <div style={{background:'#fff',padding:'15px',maxWidth:'700px',margin:'60px auto',borderRadius:'4px', maxHeight:'80vh', overflowY:'auto'}}>
                            <h6>Addendums</h6>
                            <select className="form-control" onChange={(e)=>fetchAddendum(e.target.value)} defaultValue="">
                                <option value="" disabled>Select Addendum</option>
                                {SP_PageDetails.Addendums.map(a=> <option key={a.id} value={a.id}>{a.name}</option> )}
                            </select>
                            {(() => { // show status if already submitted
                                const selectedObj = SP_PageDetails.AddendumsDetailed.find(a => a.id === selectedAddendum);
                                if (selectedAddendum && selectedObj && selectedObj.submitted) {
                                    return <div className="mt-2" style={{fontSize:'11px', color:'#28a745'}}>This addendum has already been submitted.</div>;
                                }
                                return null;
                            })()}
                            <div className="mt-3">
                                {(() => {
                                    const selectedObj = SP_PageDetails.AddendumsDetailed.find(a => a.id.toString() === selectedAddendum.toString());
                                    const alreadySubmitted = selectedAddendum && selectedObj && (selectedObj.submitted);
                                    const canUnsubmit = selectedObj && selectedObj.show_unsubmit === true;
                                    return (
                                        <div style={{width:'100%'}}>
                                                {selectedObj && selectedObj.content
                                                    ?  <div id={'content'} style={{
                                                        border: '1px solid #e0e0e0',
                                                        borderRadius: '4px',
                                                        padding: '10px',
                                                        maxHeight: '50vh',
                                                        overflowY: 'auto',
                                                        overflowX: 'hidden',
                                                        wordBreak: 'break-word',
                                                        whiteSpace: 'normal',
                                                        fontSize: '12px',
                                                        color: '#333',
                                                        background: '#fafafa'
                                                    }}> <span dangerouslySetInnerHTML={{__html: selectedObj.content}} />
                                            </div> : ''}
                                            <div className="d-flex justify-content-end align-items-center mt-2" style={{width:'100%'}}>
                                                <button
                                                    disabled={!selectedAddendum || loading || alreadySubmitted}
                                                    onClick={submitAddendum}
                                                    className="btn btn-primary btn-sm"
                                                >
                                                    {(!selectedAddendum && !loading) ? 'Submit' : (alreadySubmitted ? 'Submitted' : (loading ? 'Loading...' : 'Submit'))}
                                                </button>
                                                {canUnsubmit && (
                                                    <button
                                                        type="button"
                                                        className="btn btn-warning btn-sm ml-2"
                                                        disabled={loading}
                                                        onClick={unsubmitAddendum}
                                                    >
                                                        {loading ? 'Processing...' : 'Unsubmit'}
                                                    </button>
                                                )}
                                                <button onClick={()=>{setSelectedAddendumForSignature(null);
                                                    setButtonIdForSignature(null); setShowAddendumModal(false); setSelectedAddendum(''); }} className="btn btn-secondary btn-sm ml-2">Close</button>
                                            </div>
                                        </div>
                                    );
                                })()}
                            </div>
                        </div>
                    </div>
                )}
                {/* Billing Modal */}
                {Record.InvoicePaymentModal && (
                    <Modal show={Record.InvoicePaymentModal} onHide={() => Record.setInvoicePaymentModal(false)}
                        className={(() => {
                            const InputFields = (SP_PageDetails && SP_PageDetails.Header && SP_PageDetails.Header.InvoicePayment && SP_PageDetails.Header.InvoicePayment.InputFields) || {};
                            if (InputFields['billing_address'] && InputFields['billing_address'].show === true) return 'pay_deposit_modal2';
                            if (InputFields['zip_code'] && InputFields['zip_code'].show === true) return 'pay_deposit_modal3';
                            return 'pay_deposit_modal';
                        })()} style={{ top: '10%' }} >
                        <Modal.Header> <h5 style={{ color: '#37abdb', fontSize: '15px', fontWeight: 600 }}>
                            Storage Payment </h5>
                            <button onClick={() => Record.setInvoicePaymentModal(false)} style={{ color: 'red', background: 'white', border: 'white', height: '5%' }}>
                                <b className="contactInfoCloseBtn">X</b>
                            </button>
                        </Modal.Header>
                        <Modal.Body id={(() => {
                                const InputFields = (SP_PageDetails && SP_PageDetails.Header && SP_PageDetails.Header.InvoicePayment && SP_PageDetails.Header.InvoicePayment.InputFields) || {};
                                if (InputFields['billing_address'] && InputFields['billing_address'].show === true) return 'pay_deposit_modal2';
                                if (InputFields['zip_code'] && InputFields['zip_code'].show === true) return 'pay_deposit_modal3';
                                return 'pay_deposit_modal';
                            })()} style={{ overflowY: 'scroll' }} >
                            {/* Reused InvoicePaymentForm to allow updating billing info same as invoice payment */}
                            <InvoicePaymentForm FormatVisible={Record.FormatVisible} Tip={Record.Tip} />
                        </Modal.Body>
                    </Modal>
                )}

                {showPayNowModal && (
                    <StoragePayNowModal
                        show={showPayNowModal}
                        onHide={() => setShowPayNowModal(false)}
                        monthlyFee={parseFloat(StorageAccount.MonthlyFee) || 0}
                        lastBalance={(() => {
                            // Attempt to derive last balance from BillingHistory
                            if (BillingHistory && BillingHistory.length > 0) {
                                const last = BillingHistory[0]; // assuming first item newest based on slice earlier
                                const bal = parseFloat(last.Balance);
                                if (!isNaN(bal)) return bal;
                            }
                            return 0;
                        })()}
                        currency={(CompanyBranch && CompanyBranch.CurrencySymbol) || '$'}
                        storageAccountEncryptedId={Elink}
                        paymentGateway={(Header && Header.PaymentGateway) || ''}
                        paymentGatewayType={(Header && Header.PaymentGatewayType) || ''}
                        validCreditCard={Header && Header.ValidCreditCard}
                        onPaid={(msg, paymentMode) => {
                            console.log('Payment completed:', msg, paymentMode);
                            if (paymentMode === 'custom') {
                                setCustomPaymentCompleted(true);
                            }
                        }}
                    />
                )}
                {Record.showSignatureModal && (
                    <Modal show={Record.showSignatureModal} onHide={() => closeModal()} className='sign_estimate_modal'>
                        <Modal.Header>
                            <h5 style={{color: '#37abdb', fontSize: '15px', fontWeight: 600}}>SIGN STORAGE </h5>
                            <button onClick={() => Record.setShowSignatureModal(false)} style={{color: 'red', background: 'white', border: 'white', height: '5%'}}>
                                <b className='contactInfoCloseBtn'>X</b>
                            </button>
                        </Modal.Header>
                        <Modal.Body>
                            {/* Use existing SignaturePad component; pass mode/addendumId when invoked from content */}
                            {<SignaturePad
                                mode={selectedAddendumForSignature ? 'storage_addendum' : 'auto'}
                                addendumId={selectedAddendumForSignature || undefined}
                                onSigned={(resp)=>{
                                    if (selectedAddendumForSignature) { fetchAddendum(selectedAddendumForSignature); }
                                    setSelectedAddendumForSignature(null);
                                    setButtonIdForSignature(null);
                                }}
                                buttonId={buttonIdForSignature || undefined}
                            />}
                        </Modal.Body>
                    </Modal>
                )}
                {showStorageContactModal && (
                    <Modal show={showStorageContactModal} onHide={closeStorageContactModal} className='update-contact-info-wrap'>
                        <Modal.Header>
                            <h5 style={{color: '#37abdb', fontSize: '16px', fontWeight: 500}}>Update Contact Information.</h5>
                            <button onClick={closeStorageContactModal} style={{color: 'red', background: 'white', border: 'white'}}>
                                <b className="contactInfoCloseBtn">X</b>
                            </button>
                        </Modal.Header>
                        <Modal.Body>
                            {/* Replaced custom editable contacts UI with shared ContactInfoForm for consistent design */}
                            <ContactInfoForm mode='storage' initialContactPersons={ContactPersons} onHide={closeStorageContactModal} onUpdated={(updated)=> SetSP_PageDetails({...SP_PageDetails, ContactPersons: updated})}/>
                        </Modal.Body>
                    </Modal>
                )}
                {showAllInventoryModal && (
                    <Modal show={showAllInventoryModal} onHide={()=>setShowAllInventoryModal(false)} size="lg" centered>
                        <Modal.Header>
                            <Modal.Title>All Inventory</Modal.Title>
                            <button onClick={()=>setShowAllInventoryModal(false)} style={{color: 'red', background: 'white', border: 'white'}}>
                                <b className="contactInfoCloseBtn">X</b>
                            </button>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="text-center mb-2" style={{fontSize:'11px', fontWeight:600, color:'#26a9e0'}}>
                                {allInventorySummary.Cuft.toFixed(2)} CuFt / {allInventorySummary.Lbs.toFixed(2)} lbs · {allInventoryList.length} Items
                            </div>
                            <div style={{overflowX:'auto'}}>
                                <table className="estimated-cost-tbl table table-sm mb-2" style={{borderBottom:'1px dashed #9f9e9e', borderCollapse:'collapse', width:'100%'}}>
                                    <tbody>
                                    <tr style={{fontSize:'12px', color:'#000'}}>
                                        <th style={{...estimatedCostCellStyle, ...estimatedCostCellHeaderStyle}}>Quantity</th>
                                        <th style={{...estimatedCostCellStyle, ...estimatedCostCellHeaderStyle}}>Item(s)</th>
                                        <th style={{...estimatedCostCellStyle, ...estimatedCostCellHeaderStyle}}>CuFt</th>
                                        <th style={{...estimatedCostCellStyle, ...estimatedCostCellHeaderStyle}}>Lbs</th>
                                    </tr>
                                    {allInventoryList.map((inv,i)=>(
                                        <tr key={i} style={{fontSize:'12px'}}>
                                            <td style={estimatedCostCellStyle}>{inv.Qty || inv.Quantity || 1}</td>
                                            <td style={estimatedCostCellStyle}>{inv.Name || 'Unnamed Item'}</td>
                                            <td style={estimatedCostCellStyle}>{inv.Cuft || 0}</td>
                                            <td style={estimatedCostCellStyle}>{inv.Lbs || 0}</td>
                                        </tr>
                                    ))}
                                    {allInventoryList.length === 0 && !loading && (
                                        <tr><td colSpan={4} style={{textAlign:'center', fontSize:'11px', color:'#777'}}>No inventory records found.</td></tr>
                                    )}
                                    </tbody>
                                </table>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <button className="btn btn-secondary btn-sm" onClick={()=>setShowAllInventoryModal(false)}>Close</button>
                        </Modal.Footer>
                    </Modal>
                )}
                {showFullHistoryModal && (
                    <Modal show={showFullHistoryModal} onHide={()=> setShowFullHistoryModal(false)} size="lg" centered>
                        <Modal.Header>
                            <Modal.Title>Full Billing History</Modal.Title>
                            <button onClick={()=> setShowFullHistoryModal(false)} style={{color: 'red', background: 'white', border: 'white'}}>
                                <b className="contactInfoCloseBtn">X</b>
                            </button>
                        </Modal.Header>
                        <Modal.Body>
                            <div style={{overflowX:'auto'}}>
                                <table className="estimated-cost-tbl table table-sm mb-2" style={{borderBottom:'1px dashed #9f9e9e', borderCollapse:'collapse', width:'100%'}}>
                                    <tbody>
                                    <tr style={{fontSize:'12px', color:'#000'}}>
                                        <th style={{...addendumTableStyle, fontWeight:600}}>Bill Date</th>
                                        <th style={{...addendumTableStyle, fontWeight: 600}}>Description</th>
                                        <th style={{...addendumTableStyle, fontWeight: 600}}>Monthly Fees</th>
                                        <th style={{...addendumTableStyle, fontWeight: 600}}>Charged</th>
                                        <th style={{...addendumTableStyle, fontWeight: 600}}>Balance</th>
                                        <th style={{...addendumTableStyle, fontWeight: 600}}>Charged Info</th>
                                        <th style={{...addendumTableStyle, fontWeight: 600}}>Pre-paid Credits</th>
                                    </tr>
                                        {(BillingHistory || []).map((b,i)=>(
                                            <tr key={i} style={{fontSize:'12px'}}>
                                                <td style={addendumTableStyle}>{b.BillDate}</td>
                                                <td style={addendumTableStyle}>{b.Description}</td>
                                                <td style={addendumTableStyle}>{b.MonthlyFee}</td>
                                                <td style={addendumTableStyle}>
                                                    <span style={b.ChargedStriked ? {textDecoration:'line-through', textDecorationColor:'#ff0000'}: undefined}>{b.Charged}</span> <span>{b.StatusText}</span>
                                                </td>
                                                <td style={addendumTableStyle}>{b.Balance}</td>
                                                <td style={addendumTableStyle}>{b.ChargedInfo}</td>
                                                <td style={addendumTableStyle}>{b.PrepaidCredits}</td>
                                            </tr>
                                        ))}
                                        {(BillingHistory || []).length === 0 && (
                                            <tr><td colSpan={7} style={{textAlign:'center', fontSize:'11px', color:'#777'}}>No billing history records found.</td></tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <button className="btn btn-secondary btn-sm" onClick={()=> setShowFullHistoryModal(false)}>Close</button>
                        </Modal.Footer>
                    </Modal>
                )}
            </div>{/* end width-wrapper */}
        </div>
    );
};

export default StoragePortal;

